import { useEffect } from "react"
import { useCore } from "../core"
import { motion } from 'framer-motion'
import { useNavigate } from "react-router-dom"
import gsap from "gsap/all"
export const Logo = ({ pageName, animation, layoutId }) => {
  const navigate = useNavigate()
  const coreState = useCore()
  const { assets } = coreState

  useEffect(() => {
    if(pageName === 'home') {
      gsap.set(".logo", { opacity: 0, y: -100 })
      gsap.to(".logo", { duration:.21, opacity: 1, y: 0, ease: "power2.inOut" })
    }
  }, [pageName])

  if (pageName === 'home') {
    return (
      <motion.img
        data-animation="magnetic"
        layout
        variants={animation[pageName]}
        className="logo"
        src={assets.Logo.url}
        alt=""
      />
    )
  }

  return (
    <motion.img
      data-animation="magnetic"
      layout
      variants={animation[pageName]}
      className="logo"
      src={assets.Logo.url}
      onClick={() => navigate('/')}
      alt=""
    />
  )


  // useEffect(() => {
  //   gsap.set('.blade', { opacity: 0, scale: 0, transformOrigin: 'center' })
  //   gsap.to('.blade', { opacity: 1, scale: 1, duration: .3, stagger: .1, transformOrigin: 'center', ease: 'elastic.out' })
  // }, [])
 
  // return (
  //   <svg
  //   onClick={() => navigate('/')}
  //     viewBox="0 0 307.44 137.82"
  //     variants={animation[pageName]}
  //     //     whileHover={{ scale: 1.1}}
  //     //     whileTap={{ scale: 0.9 }}
  //     //     transition={{ type: 'spring', stiffness: 300, damping: 20 }}
  //         className="logo"
  //   >
  //     <defs>
  //       <clipPath id="clippath">
  //         <path d="M14.16 22.46h293.28v115.36H14.16z" className="cls-1" />
  //       </clipPath>
  //       <clipPath id="clippath-2">
  //         <path
  //           d="M71.05 22.46c-1.48 0-3.54.95-4.6 1.99L53.07 38.12s-3.17 2.97-11.83 2.25h-.02c4.37 2.57 8.96 4.49 13.18 4.76.27.02.59.04.86.04.11 0 .24-.02.36-.02 14.15-.96 32.61-20.45 32.61-20.45 1.02-1.09.64-2.23-.85-2.24H71.04Z"
  //           className="cls-1"
  //         />
  //       </clipPath>
  //       <clipPath id="clippath-3">
  //         <path d="M14.16 22.46h293.28v115.36H14.16z" className="cls-1" />
  //       </clipPath>
  //       <clipPath id="clippath-4">
  //         <path
  //           d="M59.6 52.19c-.15.22-.32.49-.47.73-.05.09-.12.22-.16.32-6.24 12.74 1.41 38.47 1.41 38.47.44 1.43 1.62 1.67 2.36.38l8.16-14.14c.74-1.29.96-3.54.58-4.98l-3.69-13.01s-3.4-7.21 2.52-16.79v-.02c-4.41 2.52-8.36 5.54-10.71 9.04"
  //           className="cls-1"
  //         />
  //       </clipPath>
  //       <clipPath id="clippath-5">
  //         <path d="M14.16 22.46h293.28v115.36H14.16z" className="cls-1" />
  //       </clipPath>
  //       <clipPath id="clippath-6">
  //         <path
  //           d="m14.89 36.02 8.17 14.14c.75 1.28 2.58 2.61 4.02 2.99l13.12 3.3s7.95.67 13.28 10.59h.02c.02-5.06-.61-10-2.46-13.8-.13-.24-.28-.54-.41-.77-.05-.09-.13-.21-.19-.32-7.91-11.75-34.02-17.98-34.02-17.98-.21-.05-.41-.07-.58-.07-1.06 0-1.56.82-.94 1.93"
  //           className="cls-1"
  //         />
  //       </clipPath>
  //       <linearGradient
  //         id="linear-gradient"
  //         x1={1799.63}
  //         x2={1801.05}
  //         y1={-2050.88}
  //         y2={-2050.88}
  //         gradientTransform="translate(-41326.1 47183.53) scale(22.99)"
  //         gradientUnits="userSpaceOnUse"
  //       >
  //         <stop offset={0} stopColor="#f3c2c6" />
  //         <stop offset={0.7} stopColor="#df0e63" />
  //         <stop offset={1} stopColor="#df0e63" />
  //       </linearGradient>
  //       <linearGradient
  //         id="linear-gradient-2"
  //         x1={1746.49}
  //         x2={1747.9}
  //         y1={-1864.93}
  //         y2={-1864.93}
  //         gradientTransform="matrix(-33.69 0 0 -33.69 58924.77 -62761.23)"
  //         gradientUnits="userSpaceOnUse"
  //       >
  //         <stop offset={0} stopColor="#baa5bc" />
  //         <stop offset={0.7} stopColor="#582c5f" />
  //         <stop offset={1} stopColor="#582c5f" />
  //       </linearGradient>
  //       <linearGradient
  //         id="linear-gradient-3"
  //         x1={1848.69}
  //         x2={1850.11}
  //         y1={-1955.05}
  //         y2={-1955.05}
  //         gradientTransform="matrix(0 -33.68 33.68 0 65880.1 62343.87)"
  //         gradientUnits="userSpaceOnUse"
  //       >
  //         <stop offset={0} stopColor="#baa5bc" />
  //         <stop offset={0.7} stopColor="#582c5f" />
  //         <stop offset={1} stopColor="#582c5f" />
  //       </linearGradient>
  //       <style>
  //         {".cls-1{fill:none}.cls-4{fill:#df0e63}.cls-5{fill:#582c5f}"}
  //       </style>
  //     </defs>
  //     <path
  //     id="trademark"
  //     d="M303.5 60.97c-2.31 0-3.96-1.73-3.96-4.02 0-2.42 1.83-4.02 3.96-4.02s3.94 1.6 3.94 4.02-1.83 4.02-3.94 4.02m0-7.35c-1.74 0-3.1 1.37-3.1 3.32 0 1.83 1.18 3.33 3.1 3.33 1.72 0 3.08-1.36 3.08-3.33s-1.35-3.32-3.08-3.32m-.8 5.63h-.73V54.8h1.69c1.08 0 1.62.38 1.62 1.28 0 .81-.5 1.14-1.16 1.22l1.25 1.96h-.83l-1.15-1.9h-.69v1.9Zm.82-2.53c.55 0 1.03-.05 1.03-.7 0-.54-.53-.6-.97-.6h-.88v1.3h.82Z"
  //     className="cls-4"
  //     style={{
  //       clipPath: "url(#clippath)",
  //     }}
  //   />

  //       <g id="top-blade">
  //         <div className="blade">
  //         <path
  //           d="M87.39 22.46c1.49 0 1.86 1.16.84 2.24 0 0-18.45 19.5-32.61 20.45-.11 0-.25.02-.36.02-.28 0-.59-.03-.86-.04-14.19-.94-32.61-20.42-32.61-20.42-1.03-1.09-.64-2.23.84-2.25h16.39c1.49 0 3.55 1.05 4.61 2.1l9.36 9.6c1.12.99 2.93.98 4.04 0l9.42-9.7c1.06-1.04 3.12-1.98 4.6-2h16.34"
  //           className="cls-4"
  //         />
  //         </div>
  //         <g
  //           style={{
  //             clipPath: "url(#clippath-2)",
  //           }}
  //         >
  //           <div className="blade">
  //           <path
  //             d="M42.23 7.63h46.02v52.41H42.23z"
  //             style={{
  //               fill: "url(#linear-gradient)",
  //             }}
  //             transform="rotate(-55.28 65.242 33.837)"
  //           />
  //           </div>
  //         </g>
  //       </g>
  //       <g id="r-p-blade">
  //         <div className="blade">
  //         <path
  //           d="M62.75 92.09c-.74 1.28-1.93 1.04-2.36-.39 0 0-7.65-25.73-1.41-38.47.04-.09.11-.22.16-.32.14-.24.31-.51.47-.73 7.92-11.81 34.01-18.02 34.01-18.02 1.44-.34 2.25.56 1.52 1.85L86.95 50.2c-.74 1.29-2.68 2.56-4.11 2.95l-13.01 3.3c-1.41.48-2.31 2.05-2.01 3.5l3.69 13.01c.38 1.44.16 3.69-.58 4.98l-8.16 14.14"
  //           className="cls-5"
  //           style={{
  //             clipPath: "url(#clippath-3)",
  //           }}
  //         />
  //         </div>
  //         <g
  //           style={{
  //             clipPath: "url(#clippath-4)",
  //           }}
  //         >
  //           <div className="blade">
  //           <path
  //             d="M35.76 47.41h53.07V89.1H35.76z"
  //             style={{
  //               fill: "url(#linear-gradient-2)",
  //             }}
  //             transform="rotate(-60 62.295 68.263)"
  //           />
  //           </div>
  //         </g>
  //       </g>
  //       <g id="l-p-blade">
  //         <div className="blade">
  //         <path
  //           d="M14.9 36.02c-.73-1.3.08-2.2 1.52-1.85 0 0 26.11 6.24 34.02 17.99.06.11.15.23.19.32.13.23.28.53.41.77 6.26 12.76-1.4 38.46-1.4 38.46-.43 1.43-1.61 1.67-2.36.39l-8.2-14.2c-.74-1.27-.88-3.58-.49-5.02l3.64-12.92c.29-1.45-.62-3.02-2.02-3.5l-13.11-3.3c-1.44-.39-3.27-1.71-4.02-2.99L14.9 36.02"
  //           className="cls-5"
  //           style={{
  //             clipPath: "url(#clippath-5)",
  //           }}
  //         />
  //         </div>
  //         <g
  //           style={{
  //             clipPath: "url(#clippath-6)",
  //           }}
  //         >
  //           <path
  //             d="M8.66 26.49h50.47v48.16H8.66z"
  //             style={{
  //               fill: "url(#linear-gradient-3)",
  //             }}
  //             transform="rotate(-30 33.892 50.561)"
  //           />
  //         </g>
  //       </g>









  //     <path
  //       id="letter-c"
  //       d="M134.93 83.78c-1.42 1.76-2.14 2.41-3.54 3.34-2.07 1.31-4.56 2.01-7.11 2.01-8.19 0-14.17-6.69-14.17-15.83s5.87-15.94 13.93-15.94c2.54 0 5.1.77 7.22 2.14 1.25.77 2.02 1.42 3.74 3.2l3.43-3.14c-2.01-2.25-2.9-3.02-4.62-4.09-2.85-1.72-6.35-2.66-9.9-2.66C113 52.81 105 61.46 105 73.37s7.88 20.34 18.91 20.34c3.32 0 6.58-.78 9.24-2.26 1.63-.85 2.56-1.54 3.83-2.88-.93-1.42-1.63-3.01-2.07-4.78"
  //       className="logo-letter cls-4"
  //     />
  //     <path
  //       id="letter-o"
  //       d="M150.43 93.58c-8.12 0-13.82-5.81-13.82-14.29s5.64-14.23 13.88-14.23 13.93 5.99 13.93 14.18-6.05 14.34-13.99 14.34m.06-24.37c-5.57 0-9.31 4.09-9.31 10.2s3.8 10.12 9.31 10.12 9.31-4.2 9.31-10.36-3.79-9.96-9.31-9.96"
  //       className="logo-letter cls-4"
  //     />
  //     <path
  //       id="letter-s"
  //       d="M180.42 73.13v-.24c-.06-2.54-2.01-4.14-5.22-4.14-3.02 0-4.98 1.48-4.98 3.86s1.07 3.32 6.11 4.69c3.56.94 5.34 1.77 6.7 3.08 1.31 1.36 2.14 3.38 2.14 5.39 0 4.68-3.91 7.83-9.6 7.83-6.29 0-9.78-2.79-10.25-8.3h4.44c.29 3.02 2.31 4.68 5.7 4.68 3.08 0 5.09-1.6 5.09-3.98s-1.48-3.55-6.22-4.8c-5.93-1.54-8.6-4.09-8.6-8.24 0-4.68 3.91-7.89 9.54-7.89s9.36 2.97 9.6 8.06h-4.45Z"
  //       className="logo-letter cls-4"
  //     />
  //     <path
  //       id="letter-e"
  //       d="M191.22 80.78c.53 5.33 4.15 8.76 9.07 8.76 3.44 0 6.64-1.83 8.24-4.74l3.98 1.48c-2.32 4.57-6.94 7.3-12.15 7.3-8.12 0-13.93-5.88-13.93-14.17s5.69-14.35 13.76-14.35 13.87 5.99 13.87 13.99c0 .41 0 1.01-.06 1.72h-22.78Zm8.95-11.74c-3.02 0-5.75 1.48-7.35 3.85-.88 1.37-1.19 2.26-1.54 4.63h17.96c-.47-5.16-4.03-8.47-9.07-8.47"
  //       className="logo-letter cls-4"
  //     />
  //     <path
  //       id="letter-n"
  //       d="M220.61 65.72v3.79c2.37-3.14 4.74-4.45 8.13-4.45 2.49 0 4.79.83 6.29 2.25 1.78 1.72 2.37 3.44 2.37 7.29v18.38h-4.51V75.61c-.05-4.68-1.54-6.58-5.28-6.58-4.09 0-6.99 3.08-6.99 7.29v16.66h-4.5V65.71h4.5Z"
  //       className="logo-letter cls-4"
  //     />
  //     <path
  //       id="letter-t"
  //       d="M246.28 87.4c0 1.31.41 1.67 2.02 1.67h2.07v3.9h-4.14c-3.21 0-4.43-1.25-4.43-4.21V69.69h-3.74v-3.98h3.74v-8.65h4.49v8.65h3.76l1.3 3.98h-5.06V87.4h-.01Z"
  //       className="logo-letter cls-4"
  //     />
  //     <path
  //       id="letter-y"
  //       d="M272.34 65.72h4.86l-16.3 40.43h-4.86l5.69-14-9.72-26.43h4.75l7.4 20.22 8.18-20.22z"
  //       className="logo-letter cls-4"
  //     />
  //     <path
  //       id="letter-x"
  //       d="M279.17 92.98h-5.51l10.07-13.51-6.52-8.74 2.01-4.97 7.25 9.98 7.4-10.02h5.51l-10.25 13.75 9.78 13.51h-5.45l-6.99-9.89-7.3 9.89z"
  //       className="logo-letter cls-4"
  //     />
  //     <g id="secukinumab">
  //       <path
  //         d="M114.26 105.93c-2.19 4.72-2.97 10.4-2.97 15.94s.95 10.83 2.97 15.94h-1.3c-2.57-4.58-3.94-10.3-3.94-15.94s1.35-11.29 3.94-15.94h1.3ZM121.93 117.83c0-2.42-.49-3.73-2.13-3.73-.73 0-2.35.25-2.35 2.91 0 2.27 1.78 2.7 3.57 3.44 1.73.75 3.54 1.56 3.54 5.36s-1.97 5.97-4.67 5.97c-4.92 0-4.97-4.79-4.97-6.75h2.27c0 2.31.46 4.4 2.7 4.4.73 0 2.4-.46 2.4-3.16 0-2.56-1.81-3.13-3.54-3.87-1.76-.78-3.57-1.49-3.57-5.4 0-3.55 2.11-5.26 4.62-5.26 4.22 0 4.4 3.84 4.4 6.07h-2.27v.02ZM128.46 122.12c0 2.95 0 7.31 2.78 7.31 2.16 0 2.46-2.95 2.46-4.4h2.27c0 2.03-.89 6.75-4.86 6.75-3.57 0-5.02-3.2-5.02-9.77 0-4.72.7-10.26 5.16-10.26s4.84 5.04 4.84 9.16v1.21h-7.63Zm5.24-2.34v-1.03c0-2.13-.49-4.65-2.51-4.65-2.38 0-2.65 3.83-2.65 4.97v.71h5.16ZM145.32 118.04c0-1.85-.57-3.94-2.3-3.94-1.41 0-2.84.92-2.84 7.88 0 2.45.03 7.46 2.76 7.46 1.95 0 2.38-2.7 2.38-4.76h2.27c0 2.98-1.13 7.1-4.76 7.1s-5.02-3.2-5.02-9.77c0-4.72.7-10.26 5.16-10.26 3.97 0 4.62 4.12 4.62 6.29h-2.27ZM159.34 131.29h-2.16v-2.24h-.06c-.62 1.74-2.11 2.73-3.51 2.73-3.81 0-3.81-3.76-3.81-6.04v-13.49h2.27v13.14c0 1.46.08 3.84 2.13 3.84 1.22 0 2.86-1.1 2.86-3.84v-13.14h2.27v19.03ZM172.98 131.29h-2.64l-4.03-9.41-1.87 2.98v6.43h-2.26v-25.36h2.26v15.09h.06l5.08-8.77h2.65l-4.41 7.17 5.16 11.87zM174.17 105.93h2.27v3.41h-2.27v-3.41Zm0 6.32h2.27v19.03h-2.27v-19.03ZM179.41 112.25h2.16v2.24h.06c.62-1.74 2.11-2.73 3.51-2.73 3.81 0 3.81 3.76 3.81 6.04v13.49h-2.27v-13.14c0-1.46-.08-3.83-2.13-3.83-1.22 0-2.86 1.1-2.86 3.83v13.14h-2.27v-19.03ZM201.32 131.29h-2.16v-2.24h-.05c-.62 1.74-2.11 2.73-3.51 2.73-3.81 0-3.81-3.76-3.81-6.04v-13.49h2.27v13.14c0 1.46.08 3.84 2.13 3.84 1.22 0 2.86-1.1 2.86-3.84v-13.14h2.27v19.03ZM204.37 112.25h2.16v2.24h.05c.62-1.74 2.11-2.73 3.51-2.73 1.7 0 2.68.85 3.13 3.02.65-1.67 1.92-3.02 3.43-3.02 3.81 0 3.81 3.76 3.81 6.04v13.49h-2.27v-13.14c0-1.46-.08-3.83-1.95-3.83-1.08 0-2.7.85-2.7 3.83v13.14h-2.27v-13.14c0-1.46-.08-3.83-1.95-3.83-1.08 0-2.7.85-2.7 3.83v13.14h-2.27v-19.03h.02ZM223.17 118c0-4.3 1.4-6.25 4.86-6.25 4.4 0 4.4 3.48 4.4 5.47v10.62c0 .82-.03 1.53.7 1.53.3 0 .43-.07.54-.18v2.13c-.19.04-.76.18-1.33.18-.84 0-1.97 0-2.05-2.45h-.05c-.73 1.7-2.11 2.73-3.49 2.73-2.7 0-3.94-2.13-3.94-5.54 0-2.7.86-4.51 2.73-5.26l3.05-1.21c1.68-.67 1.65-1.31 1.65-2.87 0-1.81-.81-2.81-2.32-2.81-2.49 0-2.49 3.02-2.49 3.73v.18h-2.27.01Zm7 2.91c-.89 1.17-2.84 1.35-3.87 2.24-.73.6-1.11 1.35-1.11 3.02 0 1.95.51 3.27 2.05 3.27s2.92-1.63 2.92-3.62v-4.9ZM235.38 105.93h2.27v8.49h.05c.51-1.67 1.86-2.66 3.35-2.66 3.92 0 4.4 6.04 4.4 10.01 0 5.36-1.38 10.01-4.73 10.01-1.57 0-2.84-1.42-3.13-2.84h-.05v2.35h-2.16v-25.36Zm5.05 23.3c2.08 0 2.65-3.09 2.65-7.46s-.57-7.46-2.65-7.46c-2.46 0-2.92 3.76-2.92 7.46s.46 7.46 2.92 7.46M246.37 137.82c2.19-4.72 2.97-10.4 2.97-15.95s-.95-10.83-2.97-15.94h1.3c2.57 4.58 3.94 10.3 3.94 15.94s-1.35 11.29-3.94 15.95h-1.3Z"
  //         className="cls-5"
  //       />
  //     </g>
  //   </svg>
  // )

}